import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Row, Col, Table, Tabs, Spin, Modal, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import DateService from "../../../Services/DateService";
import "./adsSinglePage.scss";
import logo from '../../../assets/images/logo.png'
import {
  getProfileById,
  getSingleAdAnalytics,
  getPublicProfileById
} from "../../../slices/adsAnalytics/thunk";
import {
  getClicksData,
  getEnquiriesData,
  getContactsAccessedData,
} from "../../../slices/analytics/thunk";
import {
  setActiveTab,
  clearClicksData,
  clearEnquiriesData,
  clearContactsAccessedData,
} from "../../../slices/analytics/reducer";
import { fetchData } from "../../../Services/FetchData";
import { API_ENDPOINTS } from "../../../constants/apiEndPoints";
import { toast } from "react-toastify";
import { Popup_Toast } from "../../../constants/Popups_Toast";
import TableShimmer from "../../../Common/TableShimmer/TableShimmer";
import { resetSingleAd } from "../../../slices/adsAnalytics/reducer";
import ProfileHeader from "../../Components/ProfileCreation/ProfileHeader";
import ProfileDetailsCards from "../../Components/ProfileCreation/ProfileDetailsCards";
import Widget from "../Widget";
// import { mapProfileStatus, getStatusDisplay } from "../../../utils/statusMapping"; // Not used in this component

const AdsSinglePage = ({ activeProfileId }) => {
  const isUnmounted = useRef(false);
  let popupContent = Popup_Toast;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  // Profile data state
  const [profileData, setProfileData] = useState(null);

  // Legacy ad state (keeping for compatibility) - commented out as not used
  // const [activeAd, setActiveAd] = useState(null);

  // Analytics state
  const [tabType, setTabType] = useState("click");

  // UI state
  const [limitModal, setLimitModal] = useState(false);
  const [leadPopup, setLeadPopup] = useState(false);
  const [fetchedUserData, setFetchedUserData] = useState();
  const [accessedElement, setAccessedElement] = useState();
  // const [currentIsRedeemed, setCurrentIsRedeemed] = useState(false); // Removed as not needed

  // Redux selectors
  const allProfiles = useSelector((state) => state.Profiles);
  const analyticsState = useSelector((state) => state.Analytics);

  // Profile analytics counts
  const [count, setCount] = useState({
    'clicks': 0,
    'views': 0,
    'enquiry': 0,
    'accessContact': 0
  });

  // Lead data
  const [leadData, setLeadData] = useState({
    'name': '',
    'number': '',
    'location': '',
    'accessedDate': '',
    'profileImage': '',
    'age': '',
    'gender': '',
    'maritalStatus': '',
    'religion': ''
  });

  // Initial values for contact access - commented out as not used
  // const initialValues = {
  //   vendor_id: "",
  //   ad_id: "",
  //   user_id: "",
  //   type: "",
  //   message: "",
  //   location: "",
  //   user_data: {
  //     _id: "",
  //     age: null,
  //     city: {
  //       label: "",
  //       code: "",
  //     },
  //     gender: {
  //       label: "",
  //       code: "",
  //     },
  //     name: "",
  //     state: {
  //       label: "",
  //       code: "",
  //     },
  //   },
  // };

  // const [accessUserContact, setAccessUserContact] = useState(initialValues); // Removed as not needed

  const fetchLeadsData = (response) => {
    setLeadData({
      name: response?.name,
      number: response?.country_code + ' ' + response?.phone,
      accessedDate: response?.created_at,
      location: response?.city?.city?.label || response?.city?.district,
      profileImage: response?.profile_images?.[0]?.thumbnail || response?.profile_images?.[0]?.original,
      age: response?.age || response?.userData?.age || '-',
      gender: response?.gender?.label || response?.userData?.gender?.label || '-',
      maritalStatus: response?.marital_status?.label || response?.userData?.marital_status?.label || '-',
      religion: response?.religion?.label || response?.userData?.religion?.label || '-',
      caste: response?.caste?.label || response?.userData?.caste?.label || '-'
    })
  }
  // Removed getUserData and viewContact functions as they're now integrated into dataFetching

  // const loadingContent = isLoading ? (
  //     <div className="spinner sm inner">
  //         <Spin />
  //     </div>
  // ) : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  // Get profile data from Redux
  let singleAdAnalytics = useSelector((state) => state.AdAnalytics?.singleAd);
  const analyticsData = useSelector((state) => state.AdAnalytics.analyticsData);

  const accessToken = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
  const isAuthenticated = !!accessToken;

  useEffect(() => {
    if (!activeProfileId) {
      console.log('AdsSinglePage - No activeProfileId provided');
      return;
    }

    if (isAuthenticated) {
      dispatch(getProfileById(activeProfileId));
    } else {
      dispatch(getPublicProfileById(activeProfileId));
    }
  }, [activeProfileId, dispatch, isAuthenticated]);

  // Analytics data is now handled directly in the table components
  // No need for local state management

  // Process profile data when it's received
  useEffect(() => {
    if (singleAdAnalytics) {
      console.log('Processing profile data:', singleAdAnalytics);

      // Extract profile data from the API response - handle nested data structure
      const profile = singleAdAnalytics?.data || singleAdAnalytics;

      // Set profile data
      setProfileData(profile);


      // Set analytics counts from profile data
      const updatedCounts = {
        'clicks': profile?.clicks || 0,
        'views': profile?.views || 0,
        'enquiry': profile?.enquiries || 0,
        'accessContact': profile?.contacts_accessed || 0
      };
      setCount(updatedCounts);

      // Set active ad for compatibility (using profile data) - commented out as not used
      // setActiveAd({
      //   ...profile,
      //   ad_id: profile?.id,
      //   status: profile?.status,
      //   location: profile?.city?.city?.label || profile?.city?.district || profile?.location,
      //   plan: profile?.profile_advertisement?.is_purchased ? 'Premium' : 'Basic',
      //   price: profile?.profile_advertisement?.is_purchased ? 'Paid' : 'Free',
      //   target_reach: profile?.target_reach || 'N/A',
      //   reach_progress: profile?.reach_progress || 0,
      //   numberOfLeadsUsed: profile?.contacts_accessed || 0,
      //   numberOfLeadsLeft: profile?.numberOfLeadsLeft || 0
      // });
    }
  }, [singleAdAnalytics]);


  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setAccessedElement();

    // Only call the old analytics API for non-clicks/enquiry tabs
    if (tabType !== 'clicks' && tabType !== 'enquiry') {
      dispatch(
        getSingleAdAnalytics({
          limit: 10,
          page: 1,
        })
      )
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [tabType, dispatch, isAuthenticated]);

  // Safely derive a human-readable State value from varying API shapes
  const getStateDisplay = (record) => {
    // New primary source based on latest API: userData.city.state
    const userCityState = record?.userData?.city?.state;
    const userState = record?.userData?.state;
    const directState = record?.state;
    const cityState = record?.city?.state || record?.city?.region || record?.city?.state_name;

    const extractText = (stateObj) => {
      if (!stateObj) return undefined;
      if (typeof stateObj === 'string') return stateObj;
      return stateObj?.label || stateObj?.name || stateObj?.title;
    };

    return (
      extractText(userCityState) ||
      extractText(userState) ||
      extractText(directState) ||
      extractText(cityState) ||
      record?.userData?.state_label ||
      record?.state_label ||
      record?.region ||
      '-' // fallback
    );
  };
  const viewsColumns = [
    {
      title: "Date",
      key: "date",
      render: (record) => (
        <span className="md">
          {DateService.formatDateDDMMYYYY(record?.created_at)}
        </span>
      ),
    },
    {
      title: "State",
      key: "state",
      render: (record) => (
        <span className="md">{getStateDisplay(record)}</span>
      ),
    },
    {
      title: "Age",
      key: "age",
      render: (record) => <span className="md">{record.userData?.age}</span>,
    },
    {
      title: "Marital Status",
      key: "marital_status",
      render: (record) => (
        <span className="md">{record.userData?.marital_status?.label}</span>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (record) => (
        <span className="md">{record.userData?.name}</span>
      ),
    },
    // {
    //   title: "Gender",
    //   key: "gender",
    //   render: (record) => (
    //     <span className="md">{record.userData?.gender?.label}</span>
    //   ),
    // },

    // {
    //   title: "View Count",
    //   key: "view_count",
    //   render: (record) => <span className="md">{record.view_count}</span>,
    // },
    {
      title: "Contact Details",
      key: "is_redeemed",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div
              className={`data_wrap ${record.is_redeemed ? "not_active" : "active"
                }`}
            >
              <span>
                {record.is_redeemed
                  ? "View "
                  : "Access"}
              </span>
              {record?.id === accessedElement || record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )}
            </div>
          </Button>
        </span>
      ),
    },
  ];
  const enquiryColumns = [
    {
      title: "Date",
      key: "date",
      render: (record) => (
        <span className="md">
          {DateService.formatDateDDMMYYYY(record?.created_at)}
        </span>
      ),
    },
    {
      title: "State",
      key: "state",
      render: (record) => (
        <span className="md">{getStateDisplay(record)}</span>
      ),
    },
    // {
    //   title: "Place",
    //   key: "place",
    //   render: (record) => (
    //     <span className="md">{record.userData?.city?.label}</span>
    //   ),
    // },

    // {
    //   title: "Gender",
    //   key: "gender",
    //   render: (record) => (
    //     <span className="md">{record.userData?.gender?.label}</span>
    //   ),
    // },
    {
      title: "Age",
      key: "age",
      render: (record) => <span className="md">{record.userData?.age}</span>,
    },
    {
      title: "Marital Status",
      key: "marital_status",
      render: (record) => (
        <span className="md">{record.userData?.marital_status?.label}</span>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (record) => {
        return (
          <span className="md">
            {record?.name ? record?.name : record?.userData?.name}
          </span>
        );
      },
    },
    {
      title: "Contact Details",
      key: "is_redeemed",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div
              className={`data_wrap ${record.is_redeemed ? "not_active" : "active"
                }`}
            >
              <span>
                {record.is_redeemed
                  ? "View "
                  : "Access"}
              </span>
              {record?.id === accessedElement || record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )}
            </div>
          </Button>
        </span>
      ),
    },
  ];

  const contactsAccessedColumns = [
    {
      title: "Date",
      key: "date",
      render: (record) => (
        <span className="md">
          {DateService.formatDateDDMMYYYY(record?.created_at)}
        </span>
      ),
    },
    {
      title: "State",
      key: "state",
      render: (record) => (
        <span className="md">{getStateDisplay(record)}</span>
      ),
    },
    // {
    //   title: "City",
    //   key: "city",
    //   render: (record) => (
    //     <span className="md">{record.userData?.city?.label}</span>
    //   ),
    // },
    {
      title: "Age",
      key: "age",
      render: (record) => <span className="md">{record.userData?.age}</span>,
    },
    {
      title: "Gender",
      key: "gender",
      render: (record) => (
        <span className="md">{record.userData?.gender?.label}</span>
      ),
    },
    {
      title: "Marital Status",
      key: "marital_status",
      render: (record) => (
        <span className="md">{record.userData?.marital_status?.label}</span>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (record) => (
        <span className="md">{record.userData?.name}</span>
      ),
    },
    {
      title: "Contact Details",
      key: "contact_details",
      render: (record) => (
        <span className="md">
          <Button
            type="primary"
            className="p-0"
            style={{
              overflow: "hidden",
              background: "transparent",
              border: "0 px transparent",
            }}
            onClick={() => dataFetching(record)}
          >
            <div className="data_wrap not_active">
              <span>View</span>
              {record?.id === accessedElement || record?._id === accessedElement ? (
                <span
                  className={`fetched_data ${fetchedUserData ? "active" : ""}`}
                >
                  +91&nbsp;{fetchedUserData || ""}
                </span>
              ) : (
                ""
              )}
            </div>
          </Button>
        </span>
      ),
    },
  ];

  const tabsHandle = (key) => {
    console.log('Tab changed to:', key);
    setTabType(key);
    dispatch(setActiveTab(key));
    setLoading(true);

    // Fetch data based on tab type
    if (!isAuthenticated || !activeProfileId) {
      return;
    }

    if (key === 'clicks') {
      dispatch(getClicksData({
        profileId: activeProfileId,
        page: 1,
        limit: 10
      }));
    } else if (key === 'enquiry') {
      dispatch(getEnquiriesData({
        profileId: activeProfileId,
        page: 1,
        limit: 10
      }));
    } else if (key === 'contactsAccessed') {
      dispatch(getContactsAccessedData({
        profileId: activeProfileId,
        page: 1,
        limit: 10
      }));
    }
  };



  const dataFetching = async (data) => {
    if (!isAuthenticated) {
      toast.info('Please log in to access contact details.');
      return;
    }

    console.log('dataFetching called with data:', data);
    console.log('activeProfileId:', activeProfileId);
    console.log('user_id from data:', data?.user_id);
    console.log('is_redeemed:', data?.is_redeemed);

    setFetchedUserData();
    setAccessedElement(data?.id || data?._id);

    // Determine if this is an Access or View action
    const isRedeemed = data?.is_redeemed;

    try {
      setLoading(true);

      // Get user_id from the analytics data (clicks/enquiry response)
      const userId = data?.user_id;

      if (!userId) {
        throw new Error('User ID not found in analytics data');
      }

      if (!activeProfileId) {
        throw new Error('Profile ID not found');
      }

      let endPoint, payload, successMessage;

      if (isRedeemed) {
        // For redeemed contacts (View button) - call view-contact API
        endPoint = API_ENDPOINTS.ANALYTICS.VIEW_CONTACT;
        payload = {
          user_id: userId,
          profile_id: activeProfileId
        };
        successMessage = 'Contact details viewed successfully';
        console.log('Calling VIEW_CONTACT API with payload:', payload);
      } else {
        // For non-redeemed contacts (Access button) - call access-contact API
        endPoint = API_ENDPOINTS.ANALYTICS.ACCESS_CONTACT;
        payload = {
          user_id: userId,
          profile_id: activeProfileId,
          user_data: {}
        };
        successMessage = popupContent?.CONTACT_ACCESS?.SUCCESSFULLY?.content;
        console.log('Calling ACCESS_CONTACT API with payload:', payload);
      }

      const response = await fetchData(endPoint, payload);

      setFetchedUserData(response?.phone);
      fetchLeadsData(response);
      setLeadPopup(true);
      dispatch(getProfileById(activeProfileId));

      // Re-fetch clicks/enquiries/contacts accessed data to update redeemed status
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    if (tabType === 'clicks') {
        dispatch(getClicksData({
          profileId: activeProfileId,
          page: 1,
          limit: 10
        }));
      } else if (tabType === 'enquiry') {
        dispatch(getEnquiriesData({
          profileId: activeProfileId,
          page: 1,
          limit: 10
        }));
      } else if (tabType === 'contactsAccessed') {
        dispatch(getContactsAccessedData({
          profileId: activeProfileId,
          page: 1,
          limit: 10
        }));
      }

      toast.success(successMessage, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        className: "custom_toast",
      });

    } catch (error) {
      console.error("Error in dataFetching:", error);
      toast.error(error.message || 'Failed to access contact details');
    } finally {
      setLoading(false);
    }
  };

  // Removed the old useEffect since we're now calling API directly in dataFetching


  const handleCancel = () => {
    setLimitModal(false);
    setLeadPopup(false);
  };

  useEffect(() => {
    if (limitModal) {
      toast.warning(popupContent?.CONTACT_ACCESS?.LIMIT_REACHED?.content, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
        className: "custom_toast",
      });
      setTimeout(() => {
        setLimitModal(false);
      }, 1000);
    }
  }, [limitModal, popupContent?.CONTACT_ACCESS?.LIMIT_REACHED?.content]);

  useEffect(() => {
    console.log("analyticsData", analyticsData);
    console.log("singleAdAnalytics", singleAdAnalytics);
  }, [analyticsData, singleAdAnalytics]);

  useEffect(() => {
    console.log("singleAdAnalytics", singleAdAnalytics);
  }, [singleAdAnalytics]);

  useEffect(() => {
    return () => {
      isUnmounted.current = true;
      dispatch(resetSingleAd());
      dispatch(clearClicksData());
      dispatch(clearEnquiriesData());
      dispatch(clearContactsAccessedData());
    };
  }, [dispatch]);

  useEffect(() => {
    console.log("leadData", leadData);
  }, [leadData]);
  function formatDateTime(date) {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const padZero = (num) => String(num).padStart(2, '0');

    const year = date.getFullYear();
    const month = months[date.getMonth()]; // Get month name
    const day = padZero(date.getDate());

    let hours = date.getHours();
    const minutes = padZero(date.getMinutes());
    const period = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${month} ${day}, ${year}, ${padZero(hours)}:${minutes} ${period}`;
  }

  // Get the current date and time
  const currentDate = new Date();
  const formattedCurrentDate = formatDateTime(currentDate);

  const getWidgetData = () => {
    // Build widget data from profile API response
    // Prefer `profileData.analytics` when available; otherwise, fall back to counts
    if (profileData?.analytics && Array.isArray(profileData.analytics)) {
      return profileData.analytics;
    }

    // Fallback shape to keep Widget rendering predictable
    return [
      {
        type: 'views',
        title: 'Views',
        count: Number(count?.views || 0),
        icon:
          'https://india-s3-dev-photo-video-uploads.s3.ap-south-1.amazonaws.com/market-place/icons/icon1.svg',
      },
      {
        type: 'clicks',
        title: 'Clicks',
        count: Number(count?.clicks || 0),
        icon:
          'https://india-s3-dev-photo-video-uploads.s3.ap-south-1.amazonaws.com/market-place/icons/icon3.svg',
      },
      {
        type: 'enquiries',
        title: 'Interests Received',
        count: Number(count?.enquiry || 0),
        icon:
          'https://india-s3-dev-photo-video-uploads.s3.ap-south-1.amazonaws.com/market-place/icons/icon5.svg',
      },
      {
        type: 'accessed_contacts',
        title: 'Contacts Accessed',
        count: Number(count?.accessContact || 0),
        icon:
          'https://india-s3-dev-photo-video-uploads.s3.ap-south-1.amazonaws.com/market-place/icons/icon2.svg',
      },
    ];
  };

  // Determine loading state based on active tab
  const isLoading = loading || allProfiles.loading ||
    (isAuthenticated && tabType === 'clicks' && analyticsState.clicksData.loading) ||
    (isAuthenticated && tabType === 'enquiry' && analyticsState.enquiriesData.loading) ||
    (isAuthenticated && tabType === 'contactsAccessed' && analyticsState.contactsAccessedData.loading);

  const tabItems = [
    {
      label: "Details",
      key: "profileDetails",
      children: (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          <ProfileDetailsCards profileData={profileData} />
        </div>
      ),
    },
    isAuthenticated && {
      label: (
        <Tooltip title="Coming soon">
          <span>Clicks</span>
        </Tooltip>
      ),
      key: "clicks",
      disabled: true,
      children: (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          {analyticsState.clicksData.loading ? (
            <div className="table_shimmer_parent">
              <TableShimmer columns={5} rows={10} />
            </div>
          ) : analyticsState.clicksData.data.length > 0 ? (
            <Table
              columns={viewsColumns}
              dataSource={analyticsState.clicksData.data}
              pagination={{
                current: analyticsState.clicksData.currentPage,
                total: analyticsState.clicksData.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page) => {
                  dispatch(getClicksData({
                    profileId: activeProfileId,
                    page,
                    limit: 10
                  }));
                }
              }}
              className="ads_single_tab"
            />
          ) : (
            <div className="text-center p-4 no_results_data">
              <h3>No Clicks Data</h3>
              <p>No click analytics available for this profile.</p>
            </div>
          )}
        </div>
      ),
    },
    isAuthenticated && {
      label: (
        <Tooltip title="Coming soon">
          <span>Interests Received</span>
        </Tooltip>
      ),
      key: "enquiry",
      disabled: true,
      children: (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          {analyticsState.enquiriesData.loading ? (
            <div className="table_shimmer_parent">
              <TableShimmer columns={5} rows={10} />
            </div>
          ) : analyticsState.enquiriesData.data.length > 0 ? (
            <Table
              columns={enquiryColumns}
              dataSource={analyticsState.enquiriesData.data}
              pagination={{
                current: analyticsState.enquiriesData.currentPage,
                total: analyticsState.enquiriesData.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page) => {
                  dispatch(getEnquiriesData({
                    profileId: activeProfileId,
                    page,
                    limit: 10
                  }));
                }
              }}
              className="ads_single_tab"
            />
          ) : (
            <div className="text-center p-4 no_results_data">
              <h3>No Enquiries Data</h3>
              <p>No enquiry analytics available for this profile.</p>
            </div>
          )}
        </div>
      ),
    },
    isAuthenticated && {
      label: `Contacts Accessed`,
      key: "contactsAccessed",
      children: (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
          {analyticsState.contactsAccessedData.loading ? (
            <div className="table_shimmer_parent">
              <TableShimmer columns={5} rows={10} />
            </div>
          ) : analyticsState.contactsAccessedData.data.length > 0 ? (
            <Table
              columns={contactsAccessedColumns}
              dataSource={analyticsState.contactsAccessedData.data}
              pagination={{
                current: analyticsState.contactsAccessedData.currentPage,
                total: analyticsState.contactsAccessedData.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                onChange: (page) => {
                  dispatch(getContactsAccessedData({
                    profileId: activeProfileId,
                    page,
                    limit: 10
                  }));
                }
              }}
              className="ads_single_tab"
            />
          ) : (
            <div className="text-center p-4 no_results_data">
              <h3>No Contacts Accessed Data</h3>
              <p>No contact access analytics available for this profile.</p>
            </div>
          )}
        </div>
      ),
    },
  ].filter(Boolean);

  return (
    <>
      {isLoading && profileData && (
        <div className="spinner center">
          <Spin />
        </div>
      )}
      
      {/* {
                warning?.verifiedStatus === 'rejected' && (
                    <RejectedUi className={warning?.statusClass} type={'dashboard'} title={warning?.title} description={warning?.content} />
                )
            } */}

      <section className="ads block ads_single_page profile_details_view">
      <div className="public_header">
          <Link to={'/login'} className="main_logo">
          <img src={logo} alt="" /></Link>
      </div>
        <Card style={{ marginBottom: "30px", backgroundColor: 'transparent' }} className="single_page_wrap info_body" >
          <Row className="ad_wrap">
          <h2 className="text_red">Profile Details</h2>
            <Col className="ad_info bg_white" xs={24} lg={24}>
              {/* Profile Header Component */}
              <ProfileHeader
                profileData={profileData}
                type='profile_single_page'
                onProfileUpdate={() => {
                  if (activeProfileId) {
                    dispatch(getProfileById(activeProfileId));
                  }
                }}
              />
              {/* Profile Basic Information */}
              {/* {profileImage && (
                <Button
                  type="primary"
                  className="wide"
                  style={{ width: "100%", marginTop: ".7em" }}
                  onClick={handleDuplicate}
                >
                  Duplicate
                </Button>
              )} */}
            </Col>
            {
              profileData?.warnings?.description && (
                <div className="rejection_reason">
                  <h4 class="text_md text-center semibold">Reason for Rejection</h4>
                  <div className="image-selector">
                    <div className="image-selector-info error"><p className="info-text">{profileData?.warnings?.description}</p></div>
                  </div>
                </div>
              )
            }
            <div className="profile_detail_widget">
              <Widget data={getWidgetData()} />
            </div>
          </Row>
        </Card>

        <Card className="recentCard analytics_table bg_white info_body">
          {/* {(!analyticsData || !profileData) && (
            <div className="table_shimmer_parent">
              <TableShimmer columns={5} rows={10} />
            </div>
          )} */}

          <Tabs
            onChange={tabsHandle}
            className="custom_tab"
            defaultActiveKey="views"
            items={tabItems}
          />
        </Card>
      </section>
      {/* {
                limitModal && 
                 toast.warning(popupContent?.CONTACT_ACCESS?.LIMIT_REACHED?.content, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                    className: 'custom_toast'
                })
            } */}
      {/* <Modal afterClose={() => (document.body.style.overflow = 'initial')} className='sm_modal limit_reached_modal  close_btn_removed' style={{ textAlign: 'center' }} open={limitModal} footer={[
                <div style={{ textAlign: 'center' }} >
                    <Button key="submit" type="primary" className='short sm' onClick={handleCancel} >
                        Ok
                    </Button>
                </div>
            ]} onCancel={handleCancel}>
                <span className='cnt'>
                    You have reached your contact access limit.
                </span>
            </Modal> */}
      {/* onClick={handleOk} */}

      <Modal className='sm_modal lead_details_modal  close_btn_removed center_modal' style={{ textAlign: 'center' }} open={leadPopup} footer={[
        <div style={{ textAlign: 'center' }} >
          <Button key="close" type="text" className="short custom_btn" onClick={handleCancel}>
            Close
          </Button>
        </div>
      ]} onCancel={handleCancel}>
        {leadData?.number ? (
          <div className="lead_details_content">
            <h2 className="text-center text_red text_xl mb-6 semibold">Profile Details</h2>

            {/* Main Content - Two Column Layout */}
            <div className="profile_main_section">
              {/* Left Column - Profile Image */}
              <div className="profile_image_section">
                <img
                  src={leadData?.profileImage || '/default-profile.png'}
                  alt="Profile"
                  className="profile_image_main"
                  onError={(e) => {
                    e.target.src = '/default-profile.png';
                  }}
                />
              </div>

              {/* Right Column - Profile Details */}
              <div className="profile_details_section">
                <div className="profile_details_list">
                  <div className="detail_row">
                    <span className="detail_label">Name</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.name}</span></span>
                  </div>
                  <div className="detail_row">
                    <span className="detail_label">Age</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.age} yrs</span></span>
                  </div>
                  <div className="detail_row">
                    <span className="detail_label">Gender</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.gender}</span></span>
                  </div>
                  <div className="detail_row">
                    <span className="detail_label">Religion</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.religion}</span></span>
                  </div>
                  <div className="detail_row">
                    <span className="detail_label">Caste</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.caste}</span></span>
                  </div>
                  <div className="detail_row">
                    <span className="detail_label">Marital Status</span>
                    <span className="detail_value">:<span className="inner_span">{leadData?.maritalStatus}</span></span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Button */}
            <div className="contact_section">
              <Button
                type="primary"
                className="contact_button_main"
                size="large"
                block
              >
                {leadData?.number}
              </Button>
            </div>

            {/* Access Information */}
            <div className="access_info">
              <span className="date text-center sm2">
                Contact Accessed on {leadData.accessedDate ? DateService.formatDateCustom(leadData.accessedDate, true) : formattedCurrentDate}
              </span>
            </div>
          </div>
        ) : (
          <h2 className="text_lg text_red">No data available due to an API error. Please contact support</h2>
        )}

      </Modal>
    </>
  );
};

export default AdsSinglePage;

